$(document).on("change", "#daily-recap-filter-date", function(){
  __daily_recap_refresh()
})

$(document).on("click", ".daily-recap-card", function(){
  const date = $("#daily-recap-filter-date").val()
  const code = $(this).find(".machine-number").text()
  const record_id = $(this).attr("record_id")

  showModal(`Mesin ${code} | ${date}`)

  __daily_recap_show(record_id)
})

function __daily_recap_refresh(){
  const date = $("#daily-recap-filter-date")

  if (!date.val()){
    return false
  }

  $.ajax({
    url: window.location.href + "/filter",
    data: {
      date: date.val()
    },
    beforeSend: function(){
      $('.card-body').html(setSpinner())
    },
    success: function(res){
      $('.card-body').html(res)
    }
  })
}

function __daily_recap_show(id){
  const date = $("#daily-recap-filter-date").val()

  $.ajax({
    url: window.location.href + "/" + id,
    data: { date: date },
    dataType: 'script',
    success: function(res){
      $('.modal-body').html(res)
    }
  })
}
